import { configure as configureMobx } from 'mobx';
export var configure = function () {
    configureMobx({ isolateGlobalState: true });
};
//# sourceMappingURL=configure.js.map